import { render, staticRenderFns } from "./chemProcessKnowhows.vue?vue&type=template&id=5a5bbb3e"
import script from "./chemProcessKnowhows.vue?vue&type=script&lang=js"
export * from "./chemProcessKnowhows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a5bbb3e')) {
      api.createRecord('5a5bbb3e', component.options)
    } else {
      api.reload('5a5bbb3e', component.options)
    }
    module.hot.accept("./chemProcessKnowhows.vue?vue&type=template&id=5a5bbb3e", function () {
      api.rerender('5a5bbb3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/msds/chemProcessKnowhows.vue"
export default component.exports